import {observer} from 'mobx-react';
import React from 'react';
import {ThinProgressBarContainerBox} from './boxes/thin-progress-bar-container.box';
import {ThinProgressBarBox} from "./boxes/thin-progress-bar.box";

interface ThinProgressBarComponentProps {
    show: boolean;
}

export const ThinProgressBarComponent: React.FC<ThinProgressBarComponentProps> = observer((props) => {

    return (
        <ThinProgressBarContainerBox isVisible={props.show}>
            <ThinProgressBarBox />
        </ThinProgressBarContainerBox>
    );
});

